<div class="custom-table overflow-x-auto mt-[24px]">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.BRANDS_LIST.ENGLISH_NAME' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.BRANDS_LIST.ARABIC_NAME' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.BRANDS_LIST.USER_COUNT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'STORE.BRANDS_LIST.ACTIVATION' | translate }}
				</td>

				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let brand of brands
						| paginate
							: {
									itemsPerPage: brandsFilter?.paging?.pageSize,
									currentPage: brandsFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != brands?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[15px] max-mobile:px-padding-mobile-14 whitespace-nowrap flex items-center"
				>
					<img
						[src]="attachmentUrl + brand.imageUrl"
						alt=""
						class="w-[46px] h-[46px] ltr:mr-2 rtl:ml-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
					/>
					<div>
						{{ brand?.name?.en | slice : 0 : 30 }}
						{{ brand.name.en.length > 30 ? '...' : '' }}
					</div>
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[15px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ brand?.name?.ar }}
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[13px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ brand?.productCount }}
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<mat-slide-toggle
						(change)="activationState.emit(brand)"
						[checked]="brand?.isActive"
					></mat-slide-toggle>

					<span
						[ngClass]="brand?.isActive ? 'text-[#00BA88]' : 'text-[#B3261E]'"
						class="inline-block mx-[16px] max-mobile:text-font-mobile-small align-top"
					>
						{{
							brand?.isActive
								? ('ACTIONS.ACTIVE' | translate)
								: ('ACTIONS.INACTIVE' | translate)
						}}
					</span>
				</td>
				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-off-white py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-end"
				>
					<span class="">
						<img
							(click)="EditBrand(brand)"
							[src]="'assets/images/edit.svg'"
							alt=""
							class="inline-block cursor-pointer w-[16px] mx-2"
						/>
						<span>
							<img
								(click)="deleteBrand(brand)"
								class="inline-block cursor-pointer w-[16px]"
								[src]="'assets/images/delete.svg'"
								alt=""
							/>
						</span>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
